import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Pipe({
  name: 'passwordErrorMessages',
  pure: false,
  standalone: false,
})
export class PasswordErrorMessagesPipe implements PipeTransform {
  private errorMap = [
    {
      key: 'passwordEqual',
      message: 'l-error-message-equal-password',
      dataCy: 'error-no-equal-password',
    },
    {
      key: 'upperCase',
      message: 'l-error-message-upperCase-password',
      dataCy: 'error-no-upperCase-password',
    },
    {
      key: 'lowerCase',
      message: 'l-error-message-lowerCase-password',
      dataCy: 'error-no-lowerCase-password',
    },
    {
      key: 'number',
      message: 'l-error-message-number-password',
      dataCy: 'error-no-number-password',
    },
    {
      key: 'special',
      message: 'l-error-message-special-password',
      dataCy: 'error-no-special-password',
    },
    { key: 'min', message: 'l-error-message-min-password', dataCy: 'error-no-min-password' },
    { key: 'space', message: 'l-password-space-error', dataCy: 'error-no-space-password' },
  ];

  transform(formGroup: FormGroup | null): { message: string; dataCy: string }[] {
    if (!formGroup || !formGroup.errors || !formGroup.dirty || !formGroup.invalid) {
      return [];
    }

    return this.errorMap.filter((e) => formGroup.errors?.[e.key]);
  }
}
